import React from "react";
import QuotaRoundList from "./QuotaRoundList";

/**
 * บัณฑิตศึกษา ปริญญาโท (/Register/3) และปริญญาเอก (/Register/4)
 * ปกติเลือกรอบที่ /select-bundit ก่อน แล้วส่ง ?robId= มาหน้านี้
 * ถ้าเข้า /Register/3|4 ตรง ๆ ยังโชว์รายการรอบจาก API ได้
 */
function GraduateRounds({ rounds, selectedRobId, onSelect }) {
  return (
    <QuotaRoundList
      rounds={rounds}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
    />
  );
}

export default GraduateRounds;
